import React, { Component } from 'react';
import i18n from 'i18n-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default class MiniChat extends Component {
  constructor(props) {
    super(props);
  }

  componentWillMount() {

  }

  render() {
    return (

      <div className="miniChat__Wrapper">
        <div className="miniChat__Holder">

          <div className="miniUser__List">
            <text>Chat with:</text>
            <ul>
              <li className="user__Item">
                <img className="user__image" alt="user" src="https://travpromobile.com/images/jonathan.png" />
                <h5>Jonathan Cooper</h5>
              </li>
              <li className="user__Item">
                {/* <img className="user__image" alt="user" src={blair} /> */}
                <h5>Blair Saba</h5>
              </li>
              <li className="user__Item">
                <img className="user__image" alt="user" src="https://travpromobile.com/images/chris.png" />
                <h5>Chris van Workum</h5>
              </li>
              {/* <li className="user__Item">
                <img className="user__image" alt="user" src="https://front.travpromobile.com/614/user.jpg" />
                <h5>Jonathan Cooper</h5>
              </li>
              <li className="user__Item">
                <img className="user__image" alt="user" src="https://front.travpromobile.com/614/user.jpg" />
                <h5>Jonathan Cooper</h5>
              </li> */}
              {/* <li className="user__Item">
                <img className="user__image" alt="user" src="https://front.travpromobile.com/614/user.jpg" />
                <h5>Jonathan Cooper</h5>
              </li> */}
            </ul>
          </div>

          <div className="chatBlock">
            <div className="currentConversation">
              <div className="holder">
                <img className="user__image" alt="user" src="https://travpromobile.com/images/jonathan.png" />
                <text>
                  Jonathan Cooper
                  <br />
                  <div className="title">Director of Marketing</div>
                </text>
              </div>
              <div className="buttonHolder">
                <span><a href="https://www.linkedin.com/in/jlcooper522/" target="_blank">Grab Business Card &gt;</a></span>
                <span><a href="" target="_blank">Request a 1-1 meeting &gt;</a></span>
                <span className="linkedIn">
                  <a href="https://www.linkedin.com/in/jlcooper522/" target="_blank" rel="noopener noreferrer">
                    <FontAwesomeIcon icon={['fab', 'linkedin']} />
                  </a>
                </span>
              </div>
            </div>
            <div className="messages__Wrapper">
              {/* <ul> */}
              <div className="thisUserChatMessage">
                <div className="message">
                  Hey Jonathan!
                </div>
                <div className="time">
                  11:11 AM
                </div>
              </div>
              <div className="thisUserChatMessage">
                <div className="message">
                  I was wondering if anybody is interested in my ideas.
                </div>
                <div className="time">
                  11:12 AM
                </div>
              </div>
              <div className="chatMessage">
                <div className="chatUser">
                  Jonathan
                </div>
                <div className="message">
                  Yes of course, let's connect!
                </div>
                <div className="time">
                  11:13 AM
                </div>
              </div>
              {/* {this.getMessages()} */}
              {/* </ul> */}
            </div>

            <div className="chat__Input">
              <form>
                <input />
                <span>
                  <FontAwesomeIcon icon={['fas', 'images']} />
                </span>
                <button>Send</button>
              </form>
            </div>
          </div>

        </div>
      </div>
    );
  }
}
